import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { GetPackagesRequestTypes } from '..';
import { getPackages } from '..';
import { queryKey } from './query-key';

export type UseGetPackagesParams = GetPackagesRequestTypes;

/**
 * Custom hook to fetch packages using React Query.
 *
 * @param params - Parameters for fetching packages.
 */
export const useGetPackages = (params: UseGetPackagesParams) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: queryKey.packages(params),
    queryFn: async () => {
      const result = await getPackages(params);

      result.data?.forEach(p => {
        queryClient.setQueryData(queryKey.package(p.id), p);
      });

      return result;
    },
  });
};
